export default __webpack_public_path__ + "static/media/support-notes-logo-real-estate.a5142ca8.svg";